import React, { useEffect, useState, Component } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { StarIcon, UserIcon, MapPinIcon, CalendarIcon, BookIcon, ShieldCheckIcon, MessageCircleIcon, ChevronLeftIcon } from 'lucide-react';
import { useRoleTheme } from '../../hooks/useRoleTheme';
import BackButton from '../../components/UI/BackButton';
const ReaderServiceProfile = () => {
  const {
    id
  } = useParams();
  const navigate = useNavigate();
  const rt = useRoleTheme();
  const [activeTab, setActiveTab] = useState('about');
  // This would normally be fetched from an API
  const reader = {
    id: parseInt(id || '1'),
    name: 'Sarah Johnson',
    avatar: 'https://images.unsplash.com/photo-1494790108377-be9c29b29330?auto=format&fit=crop&q=80&w=200&h=200',
    readerType: ['beta', 'arc'],
    genres: ['Romance', 'Contemporary', 'YA'],
    rating: 4.8,
    reviewCount: 156,
    responseTime: '24-48 hours',
    completedReviews: 89,
    availability: 'Available',
    location: 'Portland, OR',
    joinedDate: 'January 2022',
    bio: 'Passionate reader with a keen eye for character development and plot consistency. English major with 3 years of beta reading experience. I provide detailed feedback on plot, pacing, character development, and overall story structure. My goal is to help authors refine their manuscripts while maintaining their unique voice and vision.',
    preferences: {
      genres: ['Romance', 'Contemporary', 'YA', 'Fantasy', "Women's Fiction"],
      excludes: ['Horror', 'Extreme Violence', 'Graphic Gore'],
      format: ['Digital', 'Print']
    },
    verifications: [{
      authorName: 'Emily Roberts',
      authorAvatar: 'https://images.unsplash.com/photo-1567532939604-b6b5b0db2604?auto=format&fit=crop&q=80&w=60&h=60',
      date: '2023-08-15',
      comment: 'Sarah provided exceptional feedback on my romance novel. Her insights on character development were particularly valuable.',
      bookTitle: 'Summer Whispers'
    }, {
      authorName: 'James Wilson',
      authorAvatar: 'https://images.unsplash.com/photo-1500648767791-00dcc994a43e?auto=format&fit=crop&q=80&w=60&h=60',
      date: '2023-05-22',
      comment: 'Working with Sarah was a pleasure. She caught plot inconsistencies I had missed and offered constructive solutions.',
      bookTitle: 'The Hidden Path'
    }, {
      authorName: 'Sophia Chen',
      authorAvatar: 'https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?auto=format&fit=crop&q=80&w=60&h=60',
      date: '2023-02-10',
      comment: "Sarah's attention to detail is remarkable, which helped me strengthen my YA novel's pacing and dialogue.",
      bookTitle: 'Echoes of Tomorrow'
    }],
    reviews: [{
      bookTitle: 'Midnight Roses',
      bookCover: 'https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80',
      author: 'Rebecca Taylor',
      rating: 5,
      date: '2023-09-28',
      reviewText: 'A captivating romance with well-developed characters and an engaging plot. The author masterfully creates tension between the protagonists, making their eventual connection all the more satisfying.',
      genre: 'Romance',
      platform: 'Goodreads'
    }, {
      bookTitle: 'The Last Prophecy',
      bookCover: 'https://images.unsplash.com/photo-1629992101753-56d196c8aabb?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80',
      author: 'Marcus King',
      rating: 4,
      date: '2023-08-15',
      reviewText: 'An impressive YA fantasy with a unique magic system. While the worldbuilding is excellent, some character motivations felt underdeveloped. Overall, an enjoyable read that shows great promise.',
      genre: 'YA Fantasy',
      platform: 'Amazon'
    }, {
      bookTitle: 'City of Whispers',
      bookCover: 'https://images.unsplash.com/photo-1621351183012-e2f9972dd9bf?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80',
      author: 'Olivia Martinez',
      rating: 4.5,
      date: '2023-07-02',
      reviewText: "A compelling contemporary story that tackles complex social issues with sensitivity and nuance. The protagonist's journey is both heartbreaking and inspiring. 'Contemporary Fiction'",
      platform: "BookBub'"
    }]
  };
  return <div className="min-h-screen bg-gray-50 py-8" data-id="element-14190" data-mp="1o42nvylj9gam">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14191" data-mp="1o3b0vc604qvy">
        <div className="mb-6" data-id="element-14192" data-mp="21w0plocx09wr">
          <BackButton data-id="element-14193" data-mp="21yd5zx30yc7p" />
        </div>
        {/* Profile Header */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden mb-6" data-id="element-14194" data-mp="1xvgu0p7zpecq">
          {/* Cover/Banner Image */}
          <div className="h-48 bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 relative" data-id="element-14195" data-mp="2buzrmo36d7as">
            <div className="absolute bottom-0 left-0 w-full h-full bg-black bg-opacity-20" data-id="element-14196" data-mp="26xg7x8npk2bg"></div>
          </div>
          {/* Profile Info */}
          <div className="relative px-6 pb-6" data-id="element-14197" data-mp="2vh1kltiszpsq">
            {/* Profile Picture */}
            <div className="absolute -top-16 left-6 h-32 w-32 rounded-full border-4 border-white overflow-hidden bg-purple-100 shadow-md" data-id="element-14198" data-mp="2gj934vtp4rbw">
              <img src={reader.avatar} alt={reader.name} className="h-full w-full object-cover" data-id="element-14199" data-mp="2lhal1dfdykls" />
            </div>
            {/* Contact Button */}
            <div className="flex justify-end pt-4" data-id="element-14200" data-mp="2cj73es7iu7z9">
              <button className="inline-flex items-center px-4 py-2 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-purple-600 hover:bg-purple-700" data-id="element-14201" data-mp="1xszup47bg3br">
                <MessageCircleIcon className="h-4 w-4 mr-2" data-id="element-14202" data-mp="1os1nkd1kzfoy" />
                Contact Reader
              </button>
            </div>
            {/* User Info */}
            <div className="mt-6" data-id="element-14203" data-mp="1st53ezjmpbq6">
              <div className="flex items-center" data-id="element-14204" data-mp="3vgbr5rz3ybeh">
                <h1 className="text-2xl font-bold text-gray-900" data-id="element-14205" data-mp="3vh3op8c9mj7e">
                  {reader.name}
                </h1>
                <div className="ml-2 flex items-center" data-id="element-14206" data-mp="3qoaieg15f2t7">
                  <ShieldCheckIcon className="h-4 w-4 text-green-500 mr-1" data-id="element-14207" data-mp="3lpqw2ein7p0b" />
                  <span className="text-xs text-green-600" data-id="element-14208" data-mp="3grfj3ux1wydv">
                    Verified Reader
                  </span>
                </div>
                <span className={`ml-3 px-3 py-1 ${rt.badgeRadius} text-xs font-medium ${reader.availability === 'Available' ? 'bg-green-100 text-green-800' : 'bg-yellow-100 text-yellow-800'}`} data-id="element-14209" data-mp="i8h324ijzxdq">
                  {reader.availability}
                </span>
              </div>
              <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mt-2 text-sm text-gray-600" data-id="element-14210" data-mp="49hcgrbhd8ex">
                <div className="flex items-center" data-id="element-14211" data-mp="2t3653f62xexa">
                  <UserIcon className="h-4 w-4 mr-1" data-id="element-14212" data-mp="2ozq8ujxx9gl4" />
                  Reader Type:{' '}
                  {reader.readerType.map(type => type.toUpperCase()).join(', ')}
                </div>
                {reader.location && <div className="flex items-center" data-id="element-14213" data-mp="1divqc7dfweag">
                    <MapPinIcon className="h-4 w-4 mr-1" data-id="element-14214" data-mp="1di3xh4b88unv" />
                    {reader.location}
                  </div>}
                <div className="flex items-center" data-id="element-14215" data-mp="1ibgkja09ctei">
                  <CalendarIcon className="h-4 w-4 mr-1" data-id="element-14216" data-mp="1n7x5jvc5urnd" />
                  Joined {reader.joinedDate}
                </div>
              </div>
              <div className="flex flex-wrap items-center gap-x-4 gap-y-2 mt-2" data-id="element-14217" data-mp="1s9mkvn6f1rh9">
                <div className="flex items-center text-sm text-gray-600" data-id="element-14218" data-mp="1wa6ieruwix3x">
                  <StarIcon className="h-4 w-4 text-yellow-400 mr-1" data-id="element-14219" data-mp="2176nazg0lttg" />
                  <span data-id="element-14220" data-mp="1vvnq2rml8q8">
                    {reader.rating} ({reader.reviewCount} reviews)
                  </span>
                </div>
                <div className="flex items-center text-sm text-gray-600" data-id="element-14221" data-mp="6uyupsr61p0u">
                  <ClockIcon className="h-4 w-4 mr-1" data-id="element-14222" data-mp="28qxnvawbtgjk" />
                  Response Time: {reader.responseTime}
                </div>
                <div className="flex items-center text-sm text-gray-600" data-id="element-14223" data-mp="24q5fskz6xhov">
                  <BookOpenIcon className="h-4 w-4 mr-1" data-id="element-14224" data-mp="2igh7wjvrzgg0" />
                  Completed Reviews: {reader.completedReviews}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Tabs */}
        <div className="bg-white rounded-lg shadow-md overflow-hidden" data-id="element-14225" data-mp="1ptelur8acy6n">
          <div className="border-b border-gray-200" data-id="element-14226" data-mp="1lsur1ub6q6no">
            <div className="flex overflow-x-auto" data-id="element-14227" data-mp="1zrauncdr3h1l">
              {[{
              id: 'about',
              label: 'About',
              icon: <UserIcon className="h-4 w-4" data-id="element-14228" data-mp="1uqwndwjz4b4m" />
            }, {
              id: 'verifications',
              label: 'Author Verifications',
              icon: <ShieldCheckIcon className="h-4 w-4" data-id="element-14229" data-mp="366lcoukp9m8l" />
            }, {
              id: 'reviews',
              label: 'Book Reviews',
              icon: <StarIcon className="h-4 w-4" data-id="element-14230" data-mp="wyyp3y94d8ai" />
            }].map(tab => <button key={tab.id} onClick={() => setActiveTab(tab.id)} className={`flex items-center px-4 py-3 font-medium text-sm whitespace-nowrap ${activeTab === tab.id ? 'border-b-2 border-purple-500 text-purple-600' : 'text-gray-500 hover:text-gray-700 hover:border-gray-300'}`} data-id="element-14231" data-mp="izp8wykwye6j">
                  <span className="mr-2" data-id="element-14232" data-mp="1fr0xynfirka7">{tab.icon}</span>
                  {tab.label}
                </button>)}
            </div>
          </div>
          {/* Tab Content */}
          <div className="p-6" data-id="element-14233" data-mp="16uryx9vgenol">
            {/* About Tab */}
            {activeTab === 'about' && <div className="space-y-6" data-id="element-14234" data-mp="1ukdza0nkb8y6">
                <div data-id="element-14235" data-mp="1zdfds7jux6h8">
                  <h2 className="text-lg font-medium text-gray-900 mb-3" data-id="element-14236" data-mp="1zdywvrl8u0wu">
                    About
                  </h2>
                  <p className="text-gray-700 whitespace-pre-line" data-id="element-14237" data-mp="11flo6j39rrf6">
                    {reader.bio}
                  </p>
                </div>
                <div data-id="element-14238" data-mp="shji3p4oi8l1">
                  <h2 className="text-lg font-medium text-gray-900 mb-3" data-id="element-14239" data-mp="sfyoq2u3ovor">
                    Reading Preferences
                  </h2>
                  <div className="space-y-4" data-id="element-14240" data-mp="wkogpgln1q4e">
                    <div data-id="element-14241" data-mp="iqx4u1kfpu5i">
                      <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-14242" data-mp="ipm4kbq774j5">
                        Preferred Genres
                      </h3>
                      <div className="flex flex-wrap gap-2" data-id="element-14243" data-mp="8tap5cvb9ykh">
                        {reader.preferences.genres.map(genre => <span key={genre} className={`inline-flex items-center px-3 py-1 ${rt.badgeRadius} text-xs font-medium bg-purple-100 text-purple-800`} data-id="element-14244" data-mp="dt5gfhj00q62">
                            <BookIcon className="h-3 w-3 mr-1" data-id="element-14245" data-mp="4t8liy60mv2k" />
                            {genre}
                          </span>)}
                      </div>
                    </div>
                    <div data-id="element-14246" data-mp="3qbq0aoi8jt0b">
                      <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-14247" data-mp="3qbyeqku0b6dm">
                        Content Exclusions
                      </h3>
                      <div className="flex flex-wrap gap-2" data-id="element-14248" data-mp="3m8tfqs94xmtq">
                        {reader.preferences.excludes.map(exclude => <span key={exclude} className={`inline-flex items-center px-3 py-1 ${rt.badgeRadius} text-xs font-medium bg-red-100 text-red-800`} data-id="element-14249" data-mp="3vb2kf1hq2lz7">
                            {exclude}
                          </span>)}
                      </div>
                    </div>
                    <div data-id="element-14250" data-mp="hvwmwij7axnh">
                      <h3 className="text-sm font-medium text-gray-700 mb-2" data-id="element-14251" data-mp="hwo5msrp90wc">
                        Preferred Formats
                      </h3>
                      <div className="flex flex-wrap gap-2" data-id="element-14252" data-mp="3blrvpia4gknd">
                        {reader.preferences.format.map(format => <span key={format} className={`inline-flex items-center px-3 py-1 ${rt.badgeRadius} text-xs font-medium bg-blue-100 text-blue-800`} data-id="element-14253" data-mp="3koszvdffg1oe">
                            {format}
                          </span>)}
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
            {/* Verifications Tab */}
            {activeTab === 'verifications' && <div className="space-y-6" data-id="element-14254" data-mp="c7y7irw99zok">
                <h2 className="text-lg font-medium text-gray-900 mb-3" data-id="element-14255" data-mp="29yshhe11ale7">
                  Author Verifications
                </h2>
                <p className="text-sm text-gray-600 mb-4" data-id="element-14256" data-mp="2e15oe5riopck">
                  Verified feedback from authors who have worked with{' '}
                  {reader.name}
                </p>
                <div className="space-y-4" data-id="element-14257" data-mp="21pmnwt65tkjn">
                  {reader.verifications.map((verification, index) => <div key={index} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors" data-id="element-14258" data-mp="1wrl9wmnlcbf1" data-mpi={index}>
                      <div className="flex items-start" data-id="element-14259" data-mp="2peeddcsd7osq">
                        <img src={verification.authorAvatar} alt={verification.authorName} className="h-10 w-10 rounded-full mr-4 object-cover" data-id="element-14260" data-mp="2kgcscmbdpfem" />

                        <div className="flex-1" data-id="element-14261" data-mp="2bewjwk44jnd1">
                          <div className="flex justify-between items-start" data-id="element-14262" data-mp="14zm65e47k4bu">
                            <div className="flex-1 pr-4" data-id="element-14263" data-mp="14xj6e2d96wtx">
                              <div className="flex items-center" data-id="element-14264" data-mp="zzhkzasculfa">
                                <h3 className="font-medium text-gray-900" data-id="element-14265" data-mp="2nxh3hvls2d4d">
                                  {verification.authorName}
                                </h3>
                                <div className="ml-2 flex items-center" data-id="element-14266" data-mp="2sq0h2skgt896">
                                  <ShieldCheckIcon className="h-4 w-4 text-green-500 mr-1" data-id="element-14267" data-mp="2ey3rav69rafy" />
                                  <span className="text-xs text-green-600" data-id="element-14268" data-mp="2iyxgrszd0xay">
                                    Verified Author
                                  </span>
                                </div>
                              </div>
                              <Link to={`/book/${encodeURIComponent(verification.bookTitle)}`} className="text-sm text-purple-600 hover:text-purple-800 block" data-id="element-14269" data-mp="3bkffafyycwvy">
                                Book: {verification.bookTitle}
                              </Link>
                              <p className="mt-2 text-gray-700" data-id="element-14270" data-mp="1r7pxaz44j1iq">
                                {verification.comment}
                              </p>
                            </div>
                            <div className="flex flex-col items-end shrink-0 ml-4" data-id="element-14271" data-mp="1enash0akp1gg">
                              <span className="text-xs text-gray-500 mb-2" data-id="element-14272" data-mp="1son81altn11t">
                                {new Date(verification.date).toLocaleDateString('en-US', {
                            year: 'numeric',
                            month: 'short',
                            day: 'numeric'
                          })}
                              </span>
                              <img src={verification.bookCover || `https://images.unsplash.com/photo-1544947950-fa07a98d237f?ixlib=rb-4.0.3&auto=format&fit=crop&w=100&q=80&random=${index}`} alt={verification.bookTitle} className="h-16 w-12 object-cover rounded shadow-sm" data-id="element-14273" data-mp="14y13vuexu0x3" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>}
            {/* Reviews Tab */}
            {activeTab === 'reviews' && <div className="space-y-6" data-id="element-14274" data-mp="1ybtydh6e2fpr">
                <h2 className="text-lg font-medium text-gray-900 mb-3" data-id="element-14275" data-mp="1ycluct3wefgk">
                  Book Reviews
                </h2>
                <p className="text-sm text-gray-600 mb-4" data-id="element-14276" data-mp="22ga0r8gsn508">
                  Public reviews {reader.name} has written for books
                </p>
                <div className="space-y-6" data-id="element-14277" data-mp="3ds2ivd84okd8">
                  {reader.reviews.map((review, index) => <div key={index} className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 transition-colors" data-id="element-14278" data-mp="3iqvwr6rbuddx" data-mpi={index}>
                      <div className="flex" data-id="element-14279" data-mp="3ny2dfsrm84gp">
                        <div className="mr-4" data-id="element-14280" data-mp="3nz3y8oyfo5bm">
                          <img src={review.bookCover} alt={review.bookTitle} className="h-24 w-16 object-cover rounded shadow-sm" data-id="element-14281" data-mp="3j5izgup0n7bd" />
                        </div>
                        <div className="flex-1" data-id="element-14282" data-mp="356jepy4mjckh">
                          <div className="flex justify-between items-start" data-id="element-14283" data-mp="354yg9xf6v9hc">
                            <div data-id="element-14284" data-mp="306ontukummzf">
                              <h3 className="font-medium text-gray-900" data-id="element-14285" data-mp="307q7gnfxkhsr">
                                {review.bookTitle}
                              </h3>
                              <p className="text-sm text-gray-600" data-id="element-14286" data-mp="ygd78bowqy31">
                                by {review.author}
                              </p>
                            </div>
                            <div className="flex items-center" data-id="element-14287" data-mp="1dmq3zoix277q">
                              {[...Array(5)].map((_, i) => <StarIcon key={i} className={`h-4 w-4 ${i < review.rating ? 'text-yellow-400' : 'text-gray-300'}`} data-id="element-14288" data-mp="1hnjrigsg5k03" data-mpi={i} />)}
                            </div>
                          </div>
                          <div className="flex items-center mt-1 mb-2" data-id="element-14289" data-mp="u1dax64yivy9">
                            <span className="text-xs bg-purple-100 text-purple-800 px-2 py-0.5 rounded-full mr-2" data-id="element-14290" data-mp="yz503se7w3yr">
                              {review.genre}
                            </span>
                            <span className="text-xs text-gray-500" data-id="element-14291" data-mp="pygmuzwne7mx">
                              {new Date(review.date).toLocaleDateString('en-US', {
                          year: 'numeric',
                          month: 'short',
                          day: 'numeric'
                        })}
                            </span>
                            <span className="text-xs text-gray-500 ml-2" data-id="element-14292" data-mp="338gqbdgovzvi">
                              via {review.platform}
                            </span>
                          </div>
                          <p className="text-gray-700" data-id="element-14293" data-mp="3d5uuoepc8y7g">{review.reviewText}</p>
                        </div>
                      </div>
                    </div>)}
                </div>
              </div>}
          </div>
        </div>
      </div>
    </div>;
};
export default ReaderServiceProfile;